import {nanoid} from "nanoid";

const COLOR_TYPE_SCALE = "scale";

// Color Palettes
export const LINE_COLORS_A = [
  {
    type: COLOR_TYPE_SCALE,
    hex: "#31C0F6",
    id: nanoid(),
    name: "Nineteen Eighty Four",
    value: 0,
  },
  {
    type: COLOR_TYPE_SCALE,
    hex: "#A500A5",
    id: nanoid(),
    name: "Nineteen Eighty Four",
    value: 0,
  },
  {
    type: COLOR_TYPE_SCALE,
    hex: "#FF7E27",
    id: nanoid(),
    name: "Nineteen Eighty Four",
    value: 0,
  },
];

export const DEFAULT_LINE_COLORS = LINE_COLORS_A;
